// ============================================================================
// SETUP READINESS SERVICE (ADR-0048 §2) — computed on read by the server for the
// active entity. Consumed by the Setup page, the sidebar badge and the gate a
// transaction screen shows before opening its form.
// ============================================================================

import { get } from '../client/axiosClient';
import { setupEndpoints } from '../endpoints/setup.endpoints';
import type { ApiResponse, SetupReadinessDto, SetupTenantReadinessDto } from '../types';

class SetupService {
  /** The active entity (X-Entity-ID): the badge and the gates. */
  async getReadiness(): Promise<SetupReadinessDto> {
    const r = await get<ApiResponse<SetupReadinessDto>>(setupEndpoints.readiness());
    return r.data.data ?? { entityId: '', evaluatedAt: '', capabilities: [], missingRequiredCount: 0 };
  }

  /** Every entity the user can access: the Setup page. */
  async getTenantReadiness(): Promise<SetupTenantReadinessDto> {
    const r = await get<ApiResponse<SetupTenantReadinessDto>>(`${setupEndpoints.readiness()}?scope=tenant`);
    return r.data.data ?? { evaluatedAt: '', entities: [], totalMissingRequiredCount: 0 };
  }
}

export const setupService = new SetupService();
export default setupService;
